import { computed } from '@vue/composition-api';

/**
 * Industry matches from the daily digest (`industry_matches`).
 * Reads the shared dailyDigest ref so the section stays in sync after load (avoids stale `dashboardStatGrid` mirrors).
 *
 * @param {Object} params - Configuration
 * @param {import('@vue/composition-api').Ref<Object>} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {import('@vue/composition-api').Ref<boolean>} params.loading - loading ref from useDailyDigest
 * @returns {Object} Reactive state for IndustryMatchesSection
 */
export function useIndustryMatchesSection({ dailyDigest, loading }) {
  const industryMatches = computed(() => {
    const list = dailyDigest.value?.industry_matches;
    return Array.isArray(list) ? list : [];
  });

  const loadingIndustryMatches = loading;

  return {
    industryMatches,
    loading: loadingIndustryMatches
  };
}
